import { apiClientAuth } from "../http/httpClient";


export function NewsletterApi(contentType = "application/json")
{
    const https = apiClientAuth(contentType);

    return {
               
       /**
        * GET /api/newsletters/export/csv
        * @desc    Export all newsletter subscriptions as CSV file
        * @access  Private (Admin)
        * @returns {File} CSV file with all subscriptions (id, email, createdAt)
        */
        findAll : () => https.get(`/api/newsletters`),
       
       /**
        * GET /api/newsletters
        * @desc    Retrieve all newsletter subscriptions
        * @access  Private (Admin)
        * @returns {Object} Array of all newsletters sorted by createdAt descending
        */
        getFile : () => https.get(`/api/newsletters/export/csv`),
       
               

      };
}

